import { create } from 'zustand';
import { api } from '../lib/api';

export interface CurrentUser {
  id: string;
  email: string;
  fullName: string;
  roles: string[];
  permissions: string[];
  requiresTwoFactor: boolean;
}

interface AuthState {
  user: CurrentUser | null;
  status: 'unknown' | 'loading' | 'authenticated' | 'unauthenticated';
  bootstrap: () => Promise<void>;
  setSession: (u: CurrentUser) => void;
  logout: () => Promise<void>;
  hasPermission: (key: string) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  status: 'unknown',

  /** Tenta hidratar a sessão a partir dos tokens em localStorage. */
  bootstrap: async () => {
    set({ status: 'loading' });
    try {
      const me = await api.me();
      set({
        status: 'authenticated',
        user: {
          id: me.user.id,
          email: me.user.email,
          fullName: me.user.fullName,
          roles: me.user.roles,
          permissions: me.user.permissions,
          requiresTwoFactor: me.user.twoFactorEnabled,
        },
      });
    } catch {
      set({ status: 'unauthenticated', user: null });
    }
  },

  setSession: (u) => set({ status: 'authenticated', user: u }),

  logout: async () => {
    await api.logout().catch(() => undefined);
    set({ status: 'unauthenticated', user: null });
  },

  hasPermission: (key) => get().user?.permissions.includes(key) ?? false,
}));
